import { ReactNode, RefObject } from 'react'
import PopoverCloseButton from 'ui/components/PopoverCloseButton/PopoverCloseButton'

type SplitViewLayoutProps = {
  title: string
  helpText: string | undefined
  titleId: string
  onClose: () => void
  headerActions?: ReactNode
  scrollContainerRef: RefObject<HTMLDivElement | null>
  footer?: ReactNode
  children: ReactNode
}

export function SplitViewLayout({
  title,
  helpText,
  titleId,
  onClose,
  headerActions,
  scrollContainerRef,
  footer,
  children,
}: SplitViewLayoutProps): ReactNode {
  return (
    <div className="@container/setting-editor flex h-full flex-col">
      <div className="flex flex-none flex-wrap items-start justify-between gap-x-4 gap-y-2 border-b border-grey-3 px-6 py-4">
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <h2 id={titleId} className="m-0 text-xl font-bold">
            {title}
          </h2>
          {helpText && <i className="text-sm">{helpText}</i>}
        </div>
        <div className="flex flex-none items-center gap-1">
          {headerActions}
          <PopoverCloseButton handleClose={onClose} />
        </div>
      </div>
      <div ref={scrollContainerRef} className="relative min-h-0 flex-1 overflow-y-auto">
        {children}
      </div>
      {footer && <div className="flex-none border-t border-grey-3">{footer}</div>}
    </div>
  )
}
